import React, { Component } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Label,
  Button,
  Input,
  Form,
  FormGroup,
} from "reactstrap";
import swal from "sweetalert2";
import authApi from "../../../api/auth";
import { handleError } from "@/util/errorHandler";

class ChangePassword extends Component {
  state = {
    isErrorStatus: false,
    current_password: "",
    new_password: "",
    confirm_password: "",
  };

  goBack = props => {
    this.props.history.goBack();
  };

  onSubmit = e => {
    e.preventDefault();
    if (this.state.current_password === "") {
      swal({
        title: "Warning",
        text: "Please enter current password",
        type: "warning",
      });
      return;
    }
    if (this.state.new_password === "") {
      swal({
        title: "Warning",
        text: "Please enter new password",
        type: "warning",
      });
      return;
    }
    if (this.state.confirm_password === "") {
      swal({
        title: "Warning",
        text: "Please enter re-enter password",
        type: "warning",
      });
      return;
    }
    if (this.state.confirm_password !== this.state.new_password) {
      swal({
        title: "Warning",
        text: "New password do not match",
        type: "warning",
      });
      return;
    }
    let changePassword = {
      currentPassword: this.state.current_password,
      newPassword: this.state.confirm_password,
    };
    authApi
      .changePassword(changePassword)
      .then(res => {
        swal({
          title: "Success!",
          text: "Password changed successfully.",
          type: "success",
        }).then(() => {
          this.goBack();
        });
        return res;
      })
      .catch(error => {
        this.setState({ isErrorStatus: true });
        handleError(error);
      });
  };

  onChanging_Newpassword(evt) {
    this.setState({ new_password: evt.target.value });
  }

  onChanging_Confirmpassword(evt) {
    this.setState({ confirm_password: evt.target.value });
  }

  onChanging_currentPassword(evt) {
    this.setState({ current_password: evt.target.value });
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Card>
          <Form onSubmit={e => this.onSubmit(e)}>
            <CardHeader>Change password</CardHeader>

            <CardBody>
              <FormGroup row>
                <Col md="3">
                  <Label htmlFor="text-input">
                    Current Password
                    <span className="text-danger">*</span>:
                  </Label>
                </Col>
                <Col xs="12" md="5">
                  <Input
                    type="password"
                    id="txtcurpassword"
                    placeholder="Current Password"
                    value={this.state.current_password}
                    onChange={evt => this.onChanging_currentPassword(evt)}
                    data-cy="current-password"
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Col md="3">
                  <Label htmlFor="text-input">
                    New Password
                    <span className="text-danger">*</span>:
                  </Label>
                </Col>
                <Col xs="12" md="5">
                  <Input
                    type="password"
                    id="txtnewpassword"
                    placeholder="New Password"
                    value={this.state.new_password}
                    onChange={evt => this.onChanging_Newpassword(evt)}
                    data-cy="new-password"
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Col md="3">
                  <Label htmlFor="text-input">
                    Confirm Password
                    <span className="text-danger">*</span>:
                  </Label>
                </Col>
                <Col xs="12" md="5">
                  <Input
                    type="password"
                    id="txtconfirmpassword"
                    placeholder="New Password"
                    value={this.state.confirm_password}
                    onChange={evt => this.onChanging_Confirmpassword(evt)}
                    data-cy="confirm-password"
                  />
                </Col>
              </FormGroup>
            </CardBody>
            <CardFooter>
              <Row className="d-flex justify-content-center">
                <Col>
                  <Button
                    type="reset"
                    color="black"
                    className="pull-right"
                    onClick={this.goBack}>
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    className="pull-right mr-4"
                    data-cy="submit">
                    Submit
                  </Button>
                </Col>
              </Row>
            </CardFooter>
          </Form>
        </Card>
      </div>
    );
  }
}

export default ChangePassword;
